import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ExpiredModal extends Component {
  render() {
    return (
      <div>
        <div className="modal-title">Expired Link</div>
        <div className="modal-description">The link you requested has expired</div>
        <div className="button-container">
          <div className="confirm modal-button" onClick={this.props.onClose}>
            OK
          </div>
        </div>
      </div>
    );
  }
}

ExpiredModal.displayName = 'ExpiredModal';

ExpiredModal.propTypes = {
  onClose: PropTypes.func
};

export default ExpiredModal;
